<template>
    <div class="transformer">
        <Title firstName="设备列表" lastName="DEVICE LIST"  :changeColor="true"/>
        <div class="content">
            <div class="warp">
                <div class="tree">
                    <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" node-key="id" :default-expanded-keys="[1]">
                        <span class="custom-tree-node" slot-scope="{ node }">
                            <span class="dtype">{{ node.label }}</span>
                            <div  v-if="node.childNodes.length >= 1" class="dnum">{{node.childNodes.length}}台</div>
                            <div  class="dnum" v-if="node.childNodes.length < 1">
                                {{getType(node)}}
                                <img src="../../../assets/img/positionDevice.png" alt="">
                            </div>
                        </span>
                    </el-tree>
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title')
import { GetDeviceTypeAndInfo } from '../../../components/Request'
const TYPE = {
        1: '干式变压器',
        2: '高压开关柜',
        3: '高压馈线柜',
        4: 'Pt柜',
        5: '计量柜',
        6: '高压进线柜',
        8: '油式变压器',
        9: '配电箱',
        10: '单电源进线柜',
        11: '双电源进线柜',
        12: '动力柜',
        13: '无功补偿柜',
        14: '低压馈线柜',
        16: '光伏并网柜',
        17: '低压开关柜',
        18: '枪型摄像头',
        19: '球形摄像头',
        20: '门禁',
        21: '电源进线柜',
        22: '高压出线柜',
        24: '边缘计算机网关',
        25: '有源滤波柜',
        26: '联络柜',
        27: '高清显示主机柜',
    }
export default {
    props:['areaId'],
    data(){
        return {
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        }
    },
    components:{
        Title,
    },
    mounted(){
        this.getDeviceList()
    },
    methods:{
        getType(node) {
            console.log(node);
            return TYPE[node.data.deviceInfo.deviceTypeId]
        },
        handleNodeClick(data) {
            console.log(data);
        },
        async getDeviceList(){
            let res = await GetDeviceTypeAndInfo({areaId:this.areaId})
            // let res = await GetDeviceTypeAndInfo({areaId:24})
            let deviceList = res.data.data.infos.deviceCategories
            deviceList = deviceList.find(item=>item.deviceCategoryId == 1).deviceClasses
            console.log(deviceList);
            // this.data = [deviceList]

            let arr = []
            let id = 0
            deviceList.forEach((item,index) => {
                arr[index] = {
                    id:id++,
                    label:item.deviceClassName,
                    children:[]
                }

                item.devices.forEach((val,key)=>{
                    arr[index].children[key] = {
                        id:id++,
                        label:val.deviceName,
                        deviceInfo: val,
                        modelId: val.modelId
                    }
                })
            });

            this.data = arr
            console.log(arr);



        }
    }
}
</script>

<style lang="less" scoped>
    .transformer{
        // max-height: 42vh;
        // max-height: 22vh;
        width: 20vw;
        position: fixed;
        top: 15vh;
        left: 22.7vw;
        // background-color: #fff;
        

        .content{
            position: relative;
            // height: 37vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            
            .warp{
                width: 100%;
                height: 100%;
                padding-right: 0.2vw;
                
                .tree{
                    max-height: 27vh;
                    width: 100%;
                    overflow-x: hidden;
                    overflow-y: scroll;

                    .custom-tree-node{
                        position: relative;
                        width: 100%;
                        .dnum{
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 7vw;
                            img{
                                width: 14rem;
                                height: 16rem;
                                position: absolute;
                                right: 2vw;
                                top: 0;
                            }
                        }
                    }


                    ::v-deep.el-tree{
                        background: none !important;
                        color: rgba(255, 255, 255, .7) ;

                    }

                    ::v-deep.el-tree-node__content{
                        background: none;
                        padding-left: 10rem !important;
                    }
                    ::v-deep.el-tree-node__children > .el-tree-node {
                        padding: 0.3vh 0;
                        &:hover{
                            background: linear-gradient(90deg, rgba(13, 148, 255, 0.5) 0%, rgba(13, 148, 255, 0) 100%) !important;
                        }
                    }
                    ::v-deep.el-tree-node{
                        padding: 0.3vh 0;
                        background: none;
                    }
                    ::v-deep.el-tree-node.is-current > .el-tree-node__content {
                        background: none !important;
                        
                    }

                    ::v-deep .el-icon-caret-right:before{     // 未展开
                        content: "";
                        font-size: 18px;

                    }
                    ::v-deep .expanded:before{     // 展开
                        content:"";
                        font-size: 18px;
                    }
                    
                }
                .tree::-webkit-scrollbar{
                    width: 3rem;
                }
                .tree::-webkit-scrollbar-thumb{
                    border-radius:3rem ;
                    background-color: rgba(255, 255, 255, .3);
                    height: 2px;
                }
            }
            
            

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>